import React, { Component, Fragment } from "react"
import { css } from "react-emotion"
import DisplayBlockId from "../DisplayBlockId"

const action = css`
    display: inline-block;
    cursor: pointer;
    padding: 4px;
    background: rgb(180, 0, 158);
    color: white;
    border-radius: 5px;
    border: 1px solid rgb(160, 0, 138);
    line-height: 11px;
    span {
        display: block;
        font-size: 7px;
        text-align: center;
        color: #ccc;
    }
`
const property = css`
    cursor: pointer;
    display: inline-block;
    padding: 4px;
    background: rgb(16, 124, 16);
    color: white;
    border-radius: 5px;
    border: 1px solid rgb(0, 110, 0);
    line-height: 11px;
    span {
        display: block;
        font-size: 7px;
        text-align: center;
        color: #ccc;
    }
`

const validation = css`
    cursor: pointer;
    display: inline-block;
    padding: 4px;
    background: rgb(168, 0, 0);
    color: white;
    border-radius: 5px;
    border: 1px solid rgb(148, 0, 0);
    line-height: 11px;
    span {
        display: block;
        font-size: 7px;
        text-align: center;
        color: #ccc;
    }
    em {
        margin-top: 5px;
        display: block;
        font-size: 8px;
        text-align: center;
    }
`

/**
 * @augments {Component<{broadcast: Broadcastable, showDescription?:boolean}>}
 */
class DisplayBroadcast extends Component {
    render() {
        const classNames = {
            action,
            property,
            validation,
        }

        return (
            <DisplayBlockId
                blockId={this.props.broadcast.ownerBlockId}
                className={classNames[this.props.broadcast.channel]}
                children={
                    <Fragment>
                        {!this.props.small && <span>{this.props.broadcast.channel}</span>}

                        {this.props.broadcast.published_name}
                        {this.props.showDescription && <em>{this.props.broadcast.description}</em>}
                    </Fragment>
                }
            />
        )
    }
}

DisplayBroadcast.propTypes = {}

export default DisplayBroadcast



// WEBPACK FOOTER //
// ./src/features/editor/broadcast/DisplayBroadcast.js